import { gql } from '@apollo/client';

import { SpRegistration } from '../ProviderRegister.helpers';

type SpRegistrationL3 = SpRegistration & {
  recentRequestsTitle?: string;
  metaH1?: string;
  metaH2?: string;
};

export type ProviderRegisterL3Response = {
  l3BySlug: {
    id: string;
    l2CategoryId: string;
    slug: string;
    name: string;
    requestCountSinceLastWeek?: number;
    spRegistration?: SpRegistrationL3;
  };
};

export const providerRegisterL3Query = gql`
  query ProviderRegisterL3($slug: String!) {
    l3BySlug(slug: $slug) {
      id
      l2CategoryId
      slug
      name
      requestCountSinceLastWeek
      spRegistration {
        metaTitle
        metaDescription
        coverUrl
        mobileCoverUrl
        metaH1
        metaH2
      }
    }
  }
`;
